import { FiAlertCircle } from "react-icons/fi";
import "./card.css";

const Card = (props) => {
  const { title, desc, variant, icon, handler } = props;
  return (
    <div className={variant} onClick={() => handler && handler()}>
      <div className="flex flex-row items-center justify-between h-full">
        <div className="flex flex-col items-start h-full">
          <div className="flex items-center gap-1">
            <div className="text-slate-500">{desc}</div>
            <button>
              <FiAlertCircle />
            </button>
          </div>
          <div>{title}</div>
        </div>
        <div className="flex flex-col justify-end h-full">
          <div className="bg-darker rounded-full p-5">
            <img src={icon} width={40} alt={title} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
